import { render, staticRenderFns } from "./ChangeWorkInfo.vue?vue&type=template&id=19bad517&scoped=true"
import script from "./ChangeWorkInfo.vue?vue&type=script&lang=js"
export * from "./ChangeWorkInfo.vue?vue&type=script&lang=js"
import style0 from "./ChangeWorkInfo.vue?vue&type=style&index=0&id=19bad517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bad517",
  null
  
)

export default component.exports